<template>
  <div class="container-fluid adp-container-fluid">
    <div class="row no-gutters adp-wrapper">
      <div class="adp-sidebar adp-sidebar__no-padding">
        <slot name="sidebar"></slot>
        <employee-sidebar></employee-sidebar>
      </div>

      <div class="adp-main">
        <idp :show-emp-card="false"></idp>
      </div>
    </div>
  </div>
</template>

<script>
import IDP from "./IDP";
import EmployeeSearch from "./EmployeeSearch";
import EmployeeSidebar from "./EmployeeSidebar";
import DesireCreateModal from "./modals/DesireCreateModal";
import MyTaskFilter from "./MyTaskFilter";
import MyYearFilter from "./MyYearFilter";

export default {
  name: "EmployeePage",
  data: function () {
    return {};
  },
  components: {
    'idp': IDP,
    'employee-sidebar': EmployeeSidebar,
  },
}
</script>

<style scoped>

</style>
